<template>
  <div class="navigation-header">
    <back-btn :text="text" :canReturn="canReturn" :backRoute="backRoute" :shouldPop="shouldPop" dark />
  </div>
</template>

<script>
export default {
  name: 'navigation-header',
  props: {
    text: String,
    backRoute: Object
  },
  data: function() {
    return {
      canReturn: !!this.$router.previousRoute.name,
      shouldPop: this.$router.previousRoute.name === this.backRoute.name
    }
  }
}
</script>

<style lang="scss">
.navigation-header {
  width: 100%;
  align-items: flex-start;
}
</style>
